import { ERRORS } from './settings';
import { PushNotificationsError } from './utils/error';
import type * as T from './types/sw.types';

export const installWorker = ({
  workerPath,
  workerScope,
  workerInstaller,
}: T.TWorkerSettings) => {
  if (workerInstaller instanceof Promise) {
    // схлопываем Promise
    return Promise.resolve(workerInstaller);
  }
  return window.navigator.serviceWorker.register(workerPath, {
    scope: workerScope,
  });
};

export function getWorkerList(
  pred: (swr?: ServiceWorkerRegistration) => boolean = () => true
) {
  return window.navigator.serviceWorker
    .getRegistrations()
    .then((swrList) => swrList.filter(pred));
}

export function uninstallAll() {
  return getWorkerList().then((swrList) =>
    Promise.all(swrList.map((swr) => swr.unregister()))
  );
}

export function uninstallAllInScope(scope: string) {
  return getWorkerList((swr) => swr?.scope !== scope).then((swrList) =>
    Promise.all(swrList.map((s) => s.unregister()))
  );
}

export function ready() {
  return window.navigator.serviceWorker.ready;
}

export function getSubscription(swr: ServiceWorkerRegistration) {
  return new Promise<PushSubscription>((resolve, reject) => {
    swr.pushManager.getSubscription().then((subscription) => {
      if (subscription) {
        resolve(subscription);
      } else {
        reject(new PushNotificationsError(ERRORS.GET_SUBSCRIPTION));
      }
    });
  });
}

export function removeSubscription(swr: ServiceWorkerRegistration) {
  return getSubscription(swr).then((subscription) =>
    subscription.unsubscribe().then((isSuccess) => {
      if (isSuccess) {
        return Promise.resolve(subscription);
      }
      return Promise.reject(new PushNotificationsError(ERRORS.UNSUBSCRIBE));
    })
  );
}

export function createSubscription(swr: ServiceWorkerRegistration) {
  return new Promise<PushSubscription>((resolve, reject) => {
    swr.pushManager
      .subscribe({ userVisibleOnly: true })
      .then((subscription) => {
        if (subscription) {
          resolve(subscription);
        } else {
          reject(new PushNotificationsError(ERRORS.SUBSCRIBE));
        }
      });
  });
}

export function getOrCreateSubscription(swr: ServiceWorkerRegistration) {
  return getSubscription(swr).catch(() => createSubscription(swr));
}
